import { useEffect, useState } from "react";
import { InputField } from "../common";
import useApi from "../../api";
import store from '../../assets/store.svg'
import { toast } from "react-toastify";
import { handleRetriveError } from "../../utils";

const General = () => {
  const [formData, setFormData] = useState<any>({});
  const [logo, setLogo] = useState<File | any>()
  const api = useApi();
  
  useEffect(() => {
    api.getSettings().then((response) => {
      setFormData(response);
    }, handleRetriveError);
  }, []);

  const onSubmit = (e: any) => {
    e.preventDefault();

    const dataToSubmit = { ...formData };

    if (logo) {
      dataToSubmit.logo = logo;
    } else {
      delete dataToSubmit.logo;
    }

    api.updateSettings(dataToSubmit).then((response) => {
      toast.success('Updated store details.')
    }).catch((error) => {
      console.error(error);
    });
  }

  const onChangeHandler = (e: any) =>  {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  }

  const onChangeLogo = (e: any) => {
    const file = e.target.files[0]
    setLogo(file)
    setFormData({...formData, logo: file})
  }

  return (
    <div className="h-full bg-white">
      <div className="bg-white">
        <div className="bg-white">
          <div className="bg-white">
            <h3 className="font-bold text-[18px]">Store Details</h3>
            <p className="text-base-300 text-sm py-2">
              Salesline and your customers will use this information to contact
              you.
            </p>
            <form onSubmit={onSubmit} className="pt-4">
              <div className="my-3 flex justify-center">
                <label htmlFor="logo" className="text-sm text-base-300 cursor-pointer">
                  Store Logo
                  <div className="mt-2 mb-4 bg-gray-400 w-[80px] h-[80px] rounded-full overflow-hidden flex justify-center items-center">
                   {formData.logo || logo ?
                      <img 
                        src={logo ? URL.createObjectURL(logo) : formData.logo} 
                        alt=""
                        className="w-[80px] h-[80px] rounded-full object-cover"
                      /> 
                      : 
                      <img src={store} alt="store" className="h-[40px] w-[40px]"/>
                   }
                  </div>
                </label>
                <InputField
                  id="logo"
                  type="file"
                  name="logo"
                  onChange={onChangeLogo}
                  className="hidden"
                />
              </div>
              <div className="flex flex-col sm:flex sm:flex-row justify-between gap-4">
                <div className="flex flex-col w-full">
                  <label htmlFor="site_name" className="text-sm text-base-300">
                    Site Name
                  </label>
                  <InputField
                    id="site_name"
                    type="text"
                    value={formData.site_name}
                    name='site_name'
                    onChange={onChangeHandler}
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                  />
                </div>
                <div className="flex flex-col w-full">
                  <label htmlFor="industry" className="text-sm text-base-300">
                    Company Name
                  </label>
                  <InputField
                    id="industry"
                    type="text"
                    value={formData.company_name}
                    onChange={onChangeHandler}
                    name='company_name'
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                  />
                </div>
              </div>
              <div className="flex flex-col sm:flex sm:flex-row justify-between gap-4 mt-0 sm:mt-4 ">
                <div className="flex flex-col w-full">
                  <label htmlFor="store_name" className="text-sm text-base-300">
                    Contact Email
                  </label>
                  <InputField
                    id="store_name"
                    type="email"
                    onChange={onChangeHandler}
                    name='contact_email'
                    value={formData.contact_email}
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                  />
                </div>
                <div className="flex flex-col w-full">
                  <label htmlFor="industry" className="text-sm text-base-300">
                    Contact Phone
                  </label>
                  <InputField
                    id="industry"
                    onChange={onChangeHandler}
                    value={formData.contact_phone}
                    type="text"
                    name='contact_phone'
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                  />
                </div>
              </div>
              <div className="flex flex-col sm:flex sm:flex-row justify-between gap-4 mt-0 sm:mt-4 ">
                <div className="flex flex-col w-full">
                  <label htmlFor="storeUrl" className="text-sm text-base-300">
                    Store URL
                  </label>
                  <InputField
                    id="storeUrl"
                    type="url"
                    onChange={onChangeHandler}
                    name='store_url'
                    value={formData.store_url}
                    placeholder="https://your-store.com"
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                  />
                </div>
              </div>
              <div className="flex justify-end pt-4">
                <button
                  className="bg-primary-500 py-2 px-5 w-full md:w-[200px] text-white rounded-md"
                >
                  Save changes
                </button>
              </div>
              
            </form>
          </div>
        </div>
      </div>

    </div>
  );
};

export default General;
